import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import KpsEditor from "./../editor/KpsEditor";
import { Trans } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import axios, { discussionClient } from "../../AxiosClient";
import KpsDialog from "../kps-dialog/KpsDialog";
import MuiAlert from "@material-ui/lab/Alert";
import { withSnackbar } from "notistack";
import { withTranslation } from "react-i18next";
import KpsTextField from "../KpsTextField";
import { containsScriptOrSVG, containsBadCharacter } from "../../utils/ContentChecker";
import {
  setGlobalAlert
} from "../../redux/actions/universalActions";
const styles = (theme) => ({});
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export class CreateDiscussion extends Component {
  static propTypes = {
    discussionOnId: PropTypes.number.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      discussionText: "",
      text: "",
      title: "",
      attachmentIds: [],
      openSnackbar: false,
      width: 450,
      height: 650,
      saving: false,
    };
  }
  render() {
    const { classes } = this.props;
    return (
      <>
        <KpsDialog
          id="createDiscussion"
          resize={(width, height) => this.setState({ width, height })}
          top={this.props.top}
          open={this.props.open}
          title={
            this.props.expert ? (
              <Trans i18nKey="create_expert_discussion_header" />
            ) : (
              <Trans i18nKey="create_public_discussion_header" />
            )
          }
          accept={this.saveDiscussion}
          close={() => {
            this.setState({ text: "", title: "" });
            this.props.changeOpenCreateDiscussion();
          }}
          loading={this.state.saving}
        >
          <KpsTextField
            fullWidth
            required
            id="discussion-subject"
            label="Subject"
            value={this.state.title}
            onChange={this.handleDiscussionTextChange}
            margin="normal"
          />
          {this.props.open && (
            <KpsEditor
              updateUploadArray={this.updateUploadArray}
              onChange={this.slateChange}
              newUploadId={this.newUploadId}
              ref="slate"
              height={this.state.height - 240}
              width={this.state.width - 48}
              resize={false}
            />
          )}
        </KpsDialog>
      </>
    );
  }
  updateUploadArray = (array) => {
    this.setState({ attachmentIds: array });
  };

  newUploadId = (response) => {
    let attachments = { ...this.state.attachmentIds };
    attachments.push(response);
    this.setState({ attachmentIds: attachments });
  };
  slateChange = (event) => {
    this.setState({ text: event });
  };
  handleDiscussionTextChange = (e) => {
    this.setState({ discussionText: e.target.value });
  };
  handleDiscussionTextChange = (e) => {
    this.setState({
      title: e.target.value,
    });
  };
  getValues() {
    let discussionFull = {};
    let discussion = {};
    let entry = {};
    entry.text = this.state.text;
    entry.userId = this.props.user.id;
    entry.attachmentIds = this.state.attachmentIds;
    discussion.postedById = this.props.user.id;
    discussion.title = this.state.title;
    this.props.expert
      ? (discussion.expert = this.props.expert)
      : (discussion.expert = 0);
    discussionFull.discussion = discussion;
    discussionFull.entry = entry;
    if (this.props.type === "ki") {
      discussionFull.discussing = "KNOWLEDGE_ITEM";
    } else if (this.props.type === "taxonomy") {
      discussionFull.discussing = "TAXONOMY_NODE";
    } else if (this.props.type === "topic") {
      discussionFull.discussing = "TOPIC";
    } else if (
      this.props.type === "document" &&
      (this.props.expert === 0 || !this.props.isInternal)
    ) {
      discussionFull.discussing = "DOCUMENT";
    } else if (
      this.props.type === "document" &&
      (this.props.isInternal && this.props.expert === 1)
    ) {
      discussionFull.discussing = "KNOWLEDGE_ITEM";
    }
    discussionFull.itemId = this.props.discussionOnId;
    discussionFull.knowledgeSourceId = this.props.knowledgeSourceId;
    return discussionFull;
  }

  saveDiscussion = () => {
    if (containsScriptOrSVG([this.state.text])) {
      this.props.setGlobalAlert({type:"error", message:"harmful_content", open:true})
      return;
    } else if (containsBadCharacter([this.state.text])){
      this.props.setGlobalAlert({type:"error", message:"unusable_character", open:true})
      return;
    }
    this.setState({ saving: true });
    discussionClient
      .post(`/discussion/`, {
        ...this.getValues(),
      })
      .then((res) => {
        this.props.enqueueSnackbar(
          this.props.t("discussion_create_successful"),
          {
            variant: "success",
          }
        );
        this.props.changeOpenCreateDiscussion();
        this.props.onDiscussionAdded(res.data);
      })
      .catch(() => {
        this.setState({ saving: false });
        this.props.enqueueSnackbar(this.props.t("discussion_create_error"), {
          variant: "error",
        });
      });
  };
}
const mapStateToProps = (state) => ({
  user: state.user.currentUser,
});
const mapDispatchToProps = {
  setGlobalAlert,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(withSnackbar(CreateDiscussion))));
